import apiService from '@/modules/apis/apiService'
import { useMutation } from '@tanstack/react-query'

interface Response {
  name: string
  mdn: string
  memberId: string
  isUnder14: boolean
  memberNo: number
}

export const getMemberInformation = async () => {
  const response = (await apiService.get('/api/v1/users/self')) as any
  console.log('memberNo: ', response.data.result.memberNo)
  return response.data.result as Response
}

export const useGetMemberInformationMutation = () => {
  return useMutation({
    mutationFn: getMemberInformation,
  })
}
